// -*-mode: rjsx -*-
// REACT
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"
// UTILS
import * as _ from "lodash"
import tinycolor from "tinycolor2"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"
import ExpandMore from "@material-ui/icons/ExpandMore"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"

/*
 //
 // NOTES
 //

 * we need to have 2 animations with different names
 in order for the to be retriggered every time:
 "moreFadeIn" and "lessFadeIn"
 https://css-tricks.com/restart-css-animation/

 * the whole mainDiv and moreDivExpanded have to be
 replaced completely, not just moreDivExpanded "on top"
 of the moreDiv

 // see below at
 clsx({
 [classes.moreDiv]: !isExpanded
 }, {
 [classes.moreDivExpanded]: isExpanded,
 })}
*/


const useDefaultStyles = makeStyles(theme => ({
    //
    // FlashItem hardcoded roots
    //

    // this is so that
    // more does not jump around
    // 'cause we're recalculating
    // it's width in effect after
    // it's mounted
    "@keyframes moreFadeIn": { 
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        }
    },


    "@keyframes lessFadeIn": { 
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        }
    },

    "@keyframes lessFadeOut": { 
        "0%": {
            opacity: 1,
        },
        "100%": {
            opacity: 0,
        }
    },
    

    "@keyframes moreRotate": { 
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(0deg)",
        }
    },
    

    root: {
//        maxWidth: 360,
//        maxHeight: 72,
        maxWidth: "100%",
        maxHeight: 56,
//        margin: 5,
//        marginLeft: 20,
        
        // TODO: figure out how to do height
//        maxHeight: "100%",
        overflow: "hidden",
        "&:hover": {
//            cursor: "pointer",
        },
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        // rootExpanded -> root
        transition: "max-height .45s cubic-bezier(.44,.99,.48,1)",
        // transition: "max-height 2s ease-out",
        // transitionDelay: "0.02s",
    },

    // default root, has be be after rootOverride to be able to expand
    rootExpanded: {
        overflow: "hidden !important",
    },

    mainDiv: {
    },

    mainContainer: {
        position: "relative",
    },

    moreDiv: {
        position: "absolute",
        bottom: 0,
        margin:0,
        padding: 0,
        width: "100%",
//        maxHeight: 20,
        textAlign: "right",
        
        animationName: "$moreFadeIn",
        animationDuration: "1s",
        animationFillMode: "forwards",

        "&:hover": {
//            cursor: "pointer",
        },

        userSelect: "none",

    },

    moreDivExpanded: {

        position: "absolute",
        bottom: 0,
        margin:0,
        padding: 0,
        width: "100%",
//        maxHeight: 20,
        textAlign: "right",

        animationName: "$lessFadeIn",
        animationDuration: "1s",
        animationFillMode: "forwards",

        "&:hover": {
            cursor: "pointer",
        },

        userSelect: "none",
    },

    // TODO: figure out how to move the 
    moreIcon: {
//        margin: 0,
//        marginTop: -5,
//        marginRight: 5,
        //        padding:0,

        //
        // mobile
        //
        transform: 'rotate(0deg)',
        transition: "transform 0.45s",
        margin: -10,
        marginRight: 3,
        marginBottom: -20,
        fontSize: 45,
        color: grey[400],

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            margin: -10,
            marginRight: 3,
            marginBottom: -20,
            marginTop: 0,
            fontSize: 45,
        },
        
    },
    
    lessIcon: {
//        margin: 0,
//        marginTop: -5,
//        marginRight: 5,
//        padding:0,
        transform: 'rotate(180deg)',

        margin: -10,
        marginRight: 3,
        marginBottom: -20,
        fontSize: 45,
        color: grey[400],

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            margin: -10,
            marginRight: 3,
            marginBottom: -20,
            marginTop: 0,
            fontSize: 45,
        },
    },

    noLessIcon: {
        opacity: 0,
    },


    noMoreIcon: {
        opacity: 0,
    },

        
    
}), { name: "FlashItem" })

let FlashItem = (props) => {

    // eslint-disable-next-line
    const { children, style, text, className,
            hasMore = true,
            hasLess = true,
            clickBody = false,
            // eslint-disable-next-line
            expandShape = "expand",
            expanded = false,
            fadeout = true,
          } = props

    const classes = {
        ...useDefaultStyles(),
        ...className,
    }

    // DEBUG only
    // eslint-disable-next-line
    const [isDebugLayout, setDebugLayout] = useState(false)
    //    const [isExpanded, setExpanded] = useState(false)
    const [isExpanded, setExpanded] = useState(() => { return (expanded) })
    // eslint-disable-next-line
    const [showMore, setShowMore] = useState(false)
    // eslint-disable-next-line
    const [showLess, setShowLess] = useState(false)
    const [moreBackground, setMoreBackground] = useState(false)
    const [divDim, setDivDim] = useState({width: null, height: null})

    let divRef = React.createRef()

    useEffect(() => {
        const isOverflown = (element) => {
//            console.log("<FlashItem>: isOverflown(): element.clientHeight = ", element.clientHeight)
//            console.log("<FlashItem>: isOverflown(): element.scrollHeight = ", element.scrollHeight)
            return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
        }

        const moreEffect = () => {
//            console.log("<FlashItem>: moreEffect(): divRef = ", divRef)
//            console.log("<FlashItem>: moreEffect(): isOverflown(divRef.current) = ", isOverflown(divRef.current))
            if (isOverflown(divRef.current))
                setShowMore(true)
            // else
                //                setShowMore(false)
        }

        moreEffect()
    })

    // reigh in more to be same width ad root
    useEffect(() => {
        setDivDim({
            width: divRef.current.clientWidth,
            height: divRef.current.clientHeight,
            fullHeight: divRef.current.scrollHeight,
        })
        // TODO: look up what's up with the error here: https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[divDim.width])


    useEffect(() => {
        const imageEffect = () => {
            let backgroundColor = window.getComputedStyle(divRef.current).getPropertyValue("background-color")
//            console.log("<FlashItem>: imageEffect(): backgroundColor = ", backgroundColor)
            
            let color = tinycolor(backgroundColor)
            // console.log("<FlashItem>: imageEffect(): color = ", color)
            let startColor = _.cloneDeep(color)
            startColor.setAlpha(0.0)
            // console.log("<FlashItem>: imageEffect(): startColor = ", startColor)
            let endColor = _.cloneDeep(color)
            endColor.setAlpha(0.99)
            
            if(fadeout) {
                let backgroundImage = `linear-gradient(to right, ${startColor}, ${endColor})`
                setMoreBackground(backgroundImage)
//                console.log("<FlashItem>: imageEffect(): backgroundImage = ", backgroundImage)
            }
        }

        imageEffect()
        
    })

    
    let handleMoreClick = () => {
        if(!isExpanded) {
            setExpanded(true)
        } else {
            setExpanded(false)
        }

//        console.log("<FlashItem>: handleMoreClick(): isExpanded = ", isExpanded)
    }


//    let customStyle={
//        maxHeight: !isExpanded ? divDim.height : divDim.fullHeight,
//        backgroundColor: style.backgroundColor,
//    }


    /*
    console.log("<FlashItem>: rendering...")
    console.log("<FlashItem>: children = ", children)
    console.log("<FlashItem>: style = ", style)
    console.log("<FlashItem>: classes = ", classes)
    console.log("<FlashItem>: classes.root = ", classes.root)
    console.log("<FlashItem>: showMore = ", showMore)
    console.log("<FlashItem>: divDim = ", divDim)
*/
    if(divRef.current) {
        // console.log("<FlashItem>: divRef.current.clientHeight = ", divRef.current.clientHeight)
    }
    

    // we use style from props to set the root style to this div
    // TODO: the isExpanded calculation does not work properly in IE11
    // when we refactor this, check it there as well
    return (
        <div className={classes.mainDiv}
             onClick={true ? handleMoreClick : null } style={{userSelect: "none"}}>
          <div className={classes.mainContainer}>
            <div ref={divRef} className={clsx(classes.root, {[classes.rootExpanded]: isExpanded})}
                 style={{
                     maxHeight: !isExpanded ? (style && style.maxHeight) ? style.maxHeight : divDim.height : divDim.fullHeight,
                     backgroundColor: style ? style.backgroundColor : null,
                     width: (style && style.width) ? style.width : null,
                 }}
            >
              {children}
            </div>
            <div className={
                // here we need to completely replace
                // the whole moreDiv*, one on isExplaned
                // and another on !isExplained in order to
                // regrigger the animation on more both ways
                // TODO: add a shape other than "expand",
                //       but we need to do that with a test framework
                clsx(
                    {[classes.moreDiv]: !isExpanded},
                    {[classes.moreDivExpanded]: isExpanded,}
                    )}
                 style={{
                     backgroundImage: !isExpanded ? moreBackground : null,
                     maxWidth: divDim.width,
                     margin: 0,
                 }}
                 onClick={clickBody ? null : handleMoreClick}>
              { showMore && (
                  <ExpandMore
                    className={clsx({
                        [classes.moreIcon]: (!isExpanded && hasMore),
                        [classes.noMoreIcon]: (!isExpanded && !hasMore),
                    }, {
                        [classes.lessIcon]: (isExpanded && hasLess),
                        [classes.noLessIcon]: (isExpanded && !hasLess),
                    })}/>
              )}
            </div>
          </div>
        </div>
    )
}

export default FlashItem

